import { application } from "./application"
import AxeptioController from "./axeptio_controller"
import DropdownController from "./dropdown_controller"
import NestedForm from '@stimulus-components/rails-nested-form'
import PasswordValidationController from "./password_validation_controller"

application.register("axeptio", AxeptioController)
application.register("dropdown", DropdownController)
application.register('nested-form', NestedForm)
application.register("password-validation", PasswordValidationController)
